import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

export const bearingFrequencyCalculatorPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.bearingFrequencyCalculator(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<void>>("/page-data/bearing-frequency-calculator"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
